var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Loading",

    getDefaultProps () {
        return {"width":"198px","height":"198px","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid","className":"uil-reload"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <rect x="0" y="0" width="100" height="100" fill="none" className="bk"/>
  <g>
    <path d="M50 15A35 35 0 1 0 74.787 25.213" fill="none" stroke="#2fc296" strokeWidth="12px"/>
    <path d="M50 0L50 30L66 15L50 0" fill="#2fc296" className="arrow"/>
    <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="1s" repeatCount="indefinite"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/images/icons/loading.svg